// todo @newbie012 - remove this function
export function isClipboardAvailable(): boolean {
  return true;
}
